module.exports = __webpack_public_path__ + "static/media/amisha.c0d26bed.jpg";